$(document).ready(function () {
  function setupToggle() {
    $('.js-see-all-toggle-button-wrapper').on('click', function() {
      var section = $(this).data('section');
      $('.js-see-all-toggle-container.js-' + section).toggleClass('hidden');
      $('.js-see-all-toggle-button-show.js-' + section).toggleClass('hidden');
      $('.js-see-all-toggle-button-hide.js-' + section).toggleClass('hidden');
    });
  }
  // setup when event happens e.g. part of the page is loaded via AJAX
  document.addEventListener("js-home-courses-loaded", function() {
    setupToggle();
  });

  // setup when page loads
  setupToggle();
});
